<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <v-card class="py-5">
      <v-card-title>
        {{ this.$route.params.id ? $t('clients.client.editClient') : $t('clients.client.addClient') }}
      </v-card-title>
      <template>
        <v-form
          v-model="valid"
          @submit.prevent="submitForm()"
        >
          <v-container fluid>
            <v-row class="mx-md-16 px-md-16">
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="data.name"
                  outlined
                  :label="$t('clients.clientHistory.clientName')"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="data.mobile"
                  required
                  :label="$t('clients.client.mobile')"
                  outlined
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="data.email"
                  required
                  type="email"
                  :label="$t('clients.client.email')"
                  outlined
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <label>{{ $t('clients.client.reseller') }}</label>
                <v-switch
                  v-model="data.reseller"
                  :label="$t('clients.client.chechIfReseller')"
                />
              </v-col>
            </v-row>
            <v-btn
              type="submit"
              class="mx-auto my-auto d-flex"
              color="indigo"
              :loading="loading"
              :disabled="disabled"
            >
              {{ this.$route.params.id ? $t('actions.save') : $t('actions.add') }}
            </v-btn>
          </v-container>
        </v-form>
      </template>
    </v-card>
    <v-snackbar
      v-model="successSnackbar"
      color="success"
      shaped
      absolute
      bottom
      right
      :timeout="timeout"
    >
      {{ successMessage }}
    </v-snackbar>
    <v-snackbar
      v-model="errorSnackbar"
      color="red"
      shaped
      absolute
      bottom
      right
      :timeout="timeout"
    >
      {{ errorMessage }}
    </v-snackbar>
  </v-container>
</template>
<script>
  import { ServiceFactory } from '@/services/ServiceFactory'
  const clientsService = ServiceFactory.get('clients')

  export default {
    name: 'Companies',
    data: (vm) => ({
      dataLoading: false,
      valid: false,
      data: {
        email: '',
        id: null,
        mobile: '',
        name: '',
        reseller: false,
      },
      successSnackbar: false,
      errorSnackbar: false,
      timeout: 3000,
      successMessage: '',
      errorMessage: '',
      loading: false,
      disabled: false,
    }),
    created () {
      console.log('this.$route', this.$route)
      if (this.$route.params.id) {
        this.fetchOneItem(this.$route.params.id)
      }
      this.getAllCities()
    },
    methods: {
      async  submitForm () {
        this.loading = true
        this.disabled = true
        const formData = {
          id: this.data.id,
          name: this.data.name,
          email: this.data.email,
          mobile: this.data.mobile,
          reseller: this.data.reseller,
        }
        if (this.$route.params.id) {
          this.updateContent(this.$route.params.id, formData)
        } else {
          this.newItem(formData)
        }
      },
      async newItem (data) {
        const item = await clientsService.AddNewItem(data)
        try {
          if (item.status === 'success') {
            this.successMessage = 'Item Added Successfuly'
            this.successSnackbar = true
            if (this.$route.name !== 'salesForm') {
              setTimeout(() => {
                this.$router.push('/clients/clients')
              }, 1500)
            }
            this.data = {
              email: '',
              id: null,
              mobile: '',
              name: '',
              reseller: false,
            }
          } else {
            this.errorMessage('something Error')
            this.errorSnackbar = true
          }
        } catch (err) {
          console.log('err', err)
          this.errorMessage('something Error')
          this.errorSnackbar = true
        }
        this.disabled = false
        this.loading = false
      },
      async updateContent (id, data) {
        const item = await clientsService.updateItem(id, data)
        try {
          if (item.status === 'success') {
            this.successMessage = 'Item Updated Successfuly'
            this.successSnackbar = true
            setTimeout(() => {
              this.$router.push('/clients/clients')
            }, 1500)
          } else {
            this.errorMessage('something Error')
            this.errorSnackbar = true
          }
        } catch (err) {
          console.log('err', err)
          this.errorMessage('something Error')
          this.errorSnackbar = true
          setTimeout(() => {
            this.disabled = false
            this.loading = false
          }, 1500)
        }
        this.disabled = false
        this.loading = false
      },
      async fetchOneItem (id) {
        this.dataLoading = true
        const item = await clientsService.fetchOneItem(id)
        this.data = item.data
        this.dataLoading = false
      },
    },
  }
</script>
<style>
a{
  text-decoration: none;
}
</style>
